import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Clock, Award, UserCheck, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#fafaf9] pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-26">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 max-w-2xl text-center lg:text-left" data-id="element-27">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#4a7c2c]/10 text-[#4a7c2c] text-sm font-medium mb-6" data-id="element-28">
              <UserCheck className="w-4 h-4" data-id="element-29" />
              Más de 1.578 personas ya multiplicaron sus plantas
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-30">
              Multiplica tus plantas{' '}
              <span className="text-[#4a7c2c]" data-id="element-31">sin perderlas</span> en el
              intento
            </h1>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-32">
              La guía paso a paso que te muestra exactamente qué hacer en cada
              etapa para que tus esquejes enraícen y crezcan, sin dudas ni
              prueba y error.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-33">
              {[{
              icon: UserCheck,
              text: 'Ideal para principiantes'
            }, {
              icon: Clock,
              text: 'Acceso inmediato'
            }, {
              icon: CheckCircle2,
              text: 'Método probado'
            }, {
              icon: Award,
              text: 'Sin experiencia previa'
            }].map((item, index) => <div key={index} className="flex items-center gap-2 text-gray-700" data-id="element-34">
                  <item.icon className="w-5 h-5 text-[#6b9d3e]" data-id="element-35" />
                  <span className="text-sm font-medium" data-id="element-36">{item.text}</span>
                </div>)}
            </div>

            <Button className="text-lg px-8 py-4 w-full sm:w-auto group" data-id="element-37">
              Empezar a multiplicar mis plantas
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-38" />
            </Button>

            <p className="mt-4 text-sm text-gray-500 max-w-md mx-auto lg:mx-0" data-id="element-39">
              Todo organizado en un solo lugar, sin buscar videos sueltos ni
              improvisar. Sigues pasos claros y obtienes resultados.
            </p>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 relative" data-id="element-40">
            <div className="relative z-10 rounded-2xl shadow-2xl overflow-hidden bg-white p-2 sm:p-4 rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/h45ZLkfyEb6KobfDUcdtpV/ChatGPT_Image_19_ene_2026,_03_20_12.png" alt="Guía de Esquejes Libro" className="w-full h-auto rounded-lg" data-id="element-42" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-[#6b9d3e]/20 rounded-full blur-3xl -z-10" data-id="element-43" />
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-[#4a7c2c]/20 rounded-full blur-3xl -z-10" data-id="element-44" />
          </motion.div>
        </div>
      </div>
    </section>;
}